import React from "react";
import agent from "../../images/icons8-agent-60.png";
import "../../css/testimonial.css";

const testimonials = [
  {
    name: "lakshmikandh m",
    review:
      "Thank you Sachin for all your support, encouragement, and guidance. Thank you for being patient with me as I explored different projects. I truly appreciate your patient support while I explored different projects. Your insights were invaluable and helped me a lot to make my decision. I hope you continue your excellent work.",
    rating: 5,
    link: "https://g.co/kgs/vpd82Bc",
  },
  {
    name: "Cedric Joseph",
    review:
      "It was a wonderful meeting with the dynamic team of passionate real estate consultants at 24k realtors, when we met them on the 29th of December.Led by the dynamic Mariappan who gave us a very good insight on how to look for the most appropriate investment opportunity and the rest of the team (the meeting was coordinated by Senba), it was a very good team offering excellent choices, options and are patient.I would certainly recommend 24k.",
    rating: 5,
    link: "https://g.co/kgs/S1wCj8R",
  },
  {
    name: "ARUNMOZHI N",
    review:
      "Hi All, 24k realtors good one for buying land. They will suggest based on your requirements. Thanks to senba for initiative and followup. Kudhan kumar helped me to visit all site area to get better visibility. Thanks.",
    rating: 5,
    link: "https://g.co/kgs/A7bf2sn"
  },
];

const Testimonial = () => {
  return (
    <section className="testimonial-section">
      <div className="tcontainer">
        <h2 className="tsection-title">What Our Customers Say</h2>
        <p className="section-subtitle">
          Our Real Estate Industry has the highest ratings, and we take pride in it.
        </p>

        <div className="testimonial-container">
          {testimonials.map((testimonial, index) => (
            
		 <a
              href={testimonial.link}
              target="_blank"
              rel="noopener noreferrer"
              className="testimonial-card"
              key={index}
            >
              <div className="testimonial-avatar">
                <img src={agent} alt={testimonial.name} />
              </div>
              <h3 className="testimonial-name">{testimonial.name}</h3>
              <p className="testimonial-text">{testimonial.review}</p>
              
              <div className="testimonial-rating">
                {"⭐".repeat(testimonial.rating)}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
